import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/LegalPage.css';
import SEOHelmet from '../components/SEOHelmet';

function ReturnPolicy() {
  return (
    <div className="legal-page">
      <SEOHelmet 
        title="Return Policy - Stratagease"
        description="Stratagease return policy for marketing services and digital products."
      />
      <div className="legal-container">
        <Link to="/" className="back-link">← Back to Home</Link>
        
        <h1>Return Policy</h1>
        <p className="legal-intro">Providing transparency in providing marketing services via our marketing strategy app is one of our highest priorities.</p>
        <p className="legal-intro">If you have questions about our return policy, please <a href="mailto:support@stratagease.com?subject=Return%20Policy">email us</a>.</p>

        <div className="legal-content">
          <h2>Marketing Services Refund Policy</h2>
          <p className="legal-date">Last Updated November 12, 2022</p>

          <h3>REFUNDS</h3>
          <p>All sales are final and no refund will be issued.</p>

          <h3>QUESTIONS</h3>
          <p>If you have questions concerning our refund policy, please contact us at: <a href="mailto:support@stratagease.com">support@stratagease.com</a></p>
        </div>
      </div>
    </div>
  );
}

export default ReturnPolicy;